import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Video } from '@usheru-hff/shared/domain';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'ui-video-card',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './ui-video-card.component.html',
  styleUrl: './ui-video-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiVideoCardComponent implements OnInit {
  private fullScreenService = inject(VideoFullscreenService);
  private trackingCategory = 'GalleryVideo';

  @Input({ required: true }) video: Video | undefined;

  backgroundImg = '';

  ngOnInit(): void {
    this.backgroundImg = this.video?.thumbnailUrl || '';
  }

  onPlayClick(): void {
    const settings = { content: this.video!, trackingCategory: this.trackingCategory };
    this.fullScreenService.play(settings);
  }
}
